import { Course } from '@yandex-int/k-common/typings';
import { getMe } from 'platform-components/src/components/user/selectors';
import { SelectEvent, SimpleCallback } from 'platform-components/src/typings';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

// @ts-ignore
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { getPrevYearCoursesWithDrafts } from 'store/courses/selectors';
import { getSearchStringCourseIdOrDefault } from 'utils/get-course';

import { ReduxTeacherStore, RootAction } from '../../../typings';
import * as actions from '../actions';
import PrevYearPane from '../prev-year-pane/course-view__prev-year-pane';

import DraftsLoader from './course-view__drafts-loader';

interface HOCProps extends WithRouterPathProps {
    classId?: string;
    subject?: string;
}

interface StateProps {
    courseId: number | null;
    prevYearCourses: Array<Course>;
    prevYearCourseId: number | null;
}

interface DispatchProps {
    clearLessons: SimpleCallback;
}

interface Props extends HOCProps, StateProps, DispatchProps {}

export const CourseViewDrafts = (props: Props) => {
    const {
        clearLessons,
        courseId,
        match: {
            params: { subject, classId },
        },
        prevYearCourseId: prevYearCourseIdFromProps,
        prevYearCourses,
    } = props;
    const [prevYearCourseId, setPrevYearCourseId] = useState(prevYearCourseIdFromProps || null);

    useEffect(() => {
        clearLessons();

        return () => {
            clearLessons();
        };
    }, [classId, clearLessons, subject]);

    useEffect(() => {
        setPrevYearCourseId(prevYearCourseIdFromProps || null);
    }, [prevYearCourseIdFromProps]);

    const handleSelectYear = (e: SelectEvent<number>) => {
        const {
            target: { value: selectedCourseId },
        } = e;
        setPrevYearCourseId(Number(selectedCourseId));
    };

    // при смене класса prevYearCourseId из store должен успеть поменяться на prevYearCourseIdFromProps
    const shouldShowPrevYearPane =
        Boolean(prevYearCourseId) && prevYearCourses.some(({ id }) => id === prevYearCourseId);

    return (
        <div className="course-view__current-course-lessons">
            <DraftsLoader courseId={courseId} shouldRenderEmptyMessage />
            <PrevYearPane
                courseId={prevYearCourseId}
                courses={prevYearCourses}
                onSelectCourse={handleSelectYear}
                shouldShow={shouldShowPrevYearPane}
            >
                <DraftsLoader courseId={prevYearCourseId} />
            </PrevYearPane>
        </div>
    );
};

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps): StateProps => {
    const me = getMe(storeState);
    const classId = ownProps.classId ?? ownProps.match.params.classId;
    const subject = ownProps.subject ?? ownProps.match.params.subject;
    const currentYearCourseId = getCurrentYearCourseId(storeState, {
        classId,
        subject,
    });
    // специальный костыль для КМ-ов, чтобы они могди заходить в любые курсы по get-параметру
    const currentCourseId = me ? getSearchStringCourseIdOrDefault(me, currentYearCourseId) : null;
    const prevYearCourses = getPrevYearCoursesWithDrafts(storeState, { classId, subject });
    const prevYearCourseId = prevYearCourses.length !== 0 ? prevYearCourses[0].id : null;

    return {
        courseId: currentCourseId,
        prevYearCourseId,
        prevYearCourses,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    const { clearLessons } = actions;

    return bindActionCreators(
        {
            clearLessons,
        },
        dispatch
    );
};

const CourseViewDraftsComponent = withRouterPath(connect(mapStateToProps, mapDispatchToProps)(CourseViewDrafts));

CourseViewDraftsComponent.displayName = 'CourseViewDrafts';

export default CourseViewDraftsComponent;
